import { Component, OnInit } from '@angular/core';
import { environment } from '../../../environments/environment';
import { Group } from '../../models/group';
import { NgbModalRef, NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { GroupService } from '../../services/group.service';
import { GroupsFormComponent } from '../groups-form/groups-form.component';
import { GroupsDeleteComponent } from '../groups-delete/groups-delete.component';
import { fadeInAndOut } from '../../utils/animations-utils';
import { ToastsManager } from 'ng2-toastr';
import {TranslateService} from "@ngx-translate/core";


@Component({
  selector: 'app-groups',
  animations: [fadeInAndOut()],
  templateUrl: './groups-list.component.html',
  styleUrls: ['./groups-list.component.css']
})
export class GroupsListComponent implements OnInit {

  p: number = 1;      // current page
  total: number;      // total count of records
  itemsPerPage = environment.itemPerPage;       // number of records to display on each page
  listLoading: boolean;
  downloading: boolean = false;


  filters: Map<string, any>;

  NAME_FILTER = "g.name";
  STATION_FILTER = "nbStations";
  AP_FILTER = "nbAP";
  BIKE_FILTER = "nbBikes";
  USER_FILTER = "nbUsers";
  FREEFLOATING_FILTER="g.freeFloatingEnabled";
  listFiltered = false;

  /**
   * Keys : string criterias
   * Values : boolean => true if ascending, false otherwise
   */
  sortingCriterias: Map<string, boolean> = new Map();

  /** Grp to display on the table */
  groups: Group[] = [];

  /** Modal windows */
  grpToUpdate: Group;
  grpToDelete: Group;
  deleteModal: NgbModalRef;
  formModal: NgbModalRef;
  multipleDeleteModal: NgbModalRef;

  /** Selected grps */
  selectedGrps: Map<Group, boolean> = new Map();
  selectAllChecked: boolean = false;

  constructor(private grpService: GroupService,
    private modalService: NgbModal,
    private toast : ToastsManager,
    public translateService : TranslateService) { }

  /**
   * Loads first page of results ordered by ID
   */
  ngOnInit() {
    this.initFilters();
    if (localStorage.getItem("itemsPerPage")) {
      this.itemsPerPage = parseInt(localStorage.getItem("itemsPerPage"))
    }
    this.getPage(1);
  }

  /**
   * Create a new empty object for filtering attachment points
   * Retrieve first page
   */
  clearFilters()  {
    this.listFiltered = false;
    this.initFilters();
    this.reloadList();
  }

  /**
  * Sorting system function as follow
  * On first click on a criteria => add the criteria as ascending
  * On second click => put the critiera to descending
  * On third click => remove the criteria from the map
  */
  updateSortingCriterias(criteria: string) {
    if (this.sortingCriterias.has(criteria)) {
      if (this.sortingCriterias.get(criteria)) {   // criteria is present as true => switch to false
        this.sortingCriterias.set(criteria, !this.sortingCriterias.get(criteria));
      } else {    // criteria present as false => delete it
        this.sortingCriterias.delete(criteria);
      }
    } else {
      this.sortingCriterias.set(criteria, true);
    }

  }

  initFilters() {
    this.filters = new Map();
  }

  changeItemCount(value) {
    this.itemsPerPage = value;
    this.reloadList();

    localStorage.setItem("itemsPerPage", value);
  }

  sortBy(criteria: string) {
    this.updateSortingCriterias(criteria);
    this.reloadList();
  }

  onTypeChange() {
    this.reloadList();
  }

  /**
  * Reload lists according to filters, sorting criterias from the first page
  */
  reloadList() {
    this.listFiltered = false;
    Object.values(this.filters).forEach(value => {
      if (value) {
        this.listFiltered = true;
      }
    });
    this.getPage(1);
  }

  getPage(page: number) {
    this.listLoading = true;
    this.p = page;
    this.grpService.getPaginatedFilteredSortedGroups(this.p, this.itemsPerPage, this.filters, this.sortingCriterias).subscribe(data => {
      this.groups = data.res;
      this.total = data.headers.get("x-total-count");

      this.listLoading = false;
    });
  }

  /* ------------- Modals ------------------- */
  onNewClick(): void {
    this.formModal = this.modalService.open(GroupsFormComponent);
    this.formModal.componentInstance.creationMode = true;
    this.formModal.componentInstance.grp = new Group();
    this.formModal.componentInstance.onCreateValidation.subscribe(() => this.getPage(this.p));

  }

  onUpdateClick(ap) {
    this.grpToUpdate = ap;
    this.formModal = this.modalService.open(GroupsFormComponent);
    this.formModal.componentInstance.creationMode = false;
    this.formModal.componentInstance.grp = JSON.parse(JSON.stringify(this.grpToUpdate));;
    this.formModal.componentInstance.onUpdateValidation.subscribe(() => this.getPage(this.p));
  }

  onDeleteClick(ap) {
    this.grpToDelete = ap;
    this.deleteModal = this.modalService.open(GroupsDeleteComponent, { centered: true });
    this.deleteModal.componentInstance.grp = this.grpToDelete;
    this.deleteModal.componentInstance.onDeleteValidation.subscribe(() => {
      this.groups = this.groups.filter(g => g.id != this.grpToDelete.id);
    });
  }

  selectGrp(grp: Group) {
    this.selectedGrps.set(grp, true);
  }

  deselectGrp(grp: Group) {
    this.selectedGrps.delete(grp);
    this.selectAllChecked = false;
  }

  onCheckboxSelectAllGrpChange() {
    if (this.selectedGrps.size < this.groups.length) {
      this.groups.forEach(ap => this.selectedGrps.set(ap, true));
    } else {
      this.selectedGrps.clear();
    }
  }

  onCheckboxChange(g: Group) {
    if (!this.selectedGrps.get(g)) {
      this.selectGrp(g);
    } else {
      this.deselectGrp(g);
    }
  }

  deleteSelection() {
    if (this.selectedGrps.size > 0) {
      //this.multipleDeleteModal = this.modalService.open(AttachmentpointsMultipleDeleteComponent, {size: "lg", backdrop: "static"});
      // this.multipleDeleteModal.componentInstance.attachmentPoints = Array.from(this.selectedAPs.keys());
    }
  }

  downloadXLSFile() {
    this.downloading = true;
    this.grpService.downloadXLSFile(
      this.p,
      this.itemsPerPage,
      this.filters,
      this.sortingCriterias)
      .subscribe(isTruncated => {
        if (isTruncated) {
          this.toast.warning(this.translateService.instant('common.downloadOk'));
        } else {
          this.toast.success(this.translateService.instant('common.downloadTruncated'));
        }
        this.downloading = false;
      });
  }

}



// WEBPACK FOOTER //
// ./src/app/groups/groups-list/groups-list.component.ts